// VFX: 3D Departure Board
// Category: char-reveals · Tags: text, 3d, flip, departure, kinetic
// Letras viram em Y como painel de aeroporto — caractere por caractere, stagger 3 frames.
import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring } from "remotion";
import React from "react";

const TEXT = "BOARDING";

export default function Text3DFlipDepartureBoard400Ms() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const chars = TEXT.split("");

  return (
    <AbsoluteFill style={{ alignItems: "center", justifyContent: "center", perspective: 1200, background: "#0a0e1a" }}>
      <div style={{ display: "flex", gap: 6 }}>
        {chars.map((char, i) => {
          const f = Math.max(0, frame - i * 3);
          const sp = spring({ frame: f, fps, config: { stiffness: 400, damping: 30 } });
          const angle = (1 - sp) * 90;
          return (
            <span key={i} style={{
              display: "inline-block", fontSize: 120, fontWeight: 900, fontFamily: "monospace",
              color: "#f8fafc", transformStyle: "preserve-3d",
              transform: `rotateX(${angle}deg)`,
              opacity: sp > 0.05 ? 1 : 0,
              background: "#1e293b", padding: "8px 12px", borderRadius: 6,
              boxShadow: "0 6px 18px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.06)",
              borderTop: "1px solid #475569",
              borderBottom: "1px solid #0a0e1a",
            }}>{char}</span>
          );
        })}
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
